import axios from 'axios';
import { setAlert } from './alert';
import { getCurrentAttendee } from './attendee';

import {
    EDIT_ARTIST_EVENT,
    EDIT_HOST_EVENT,
    DELETE_ARTIST_EVENT,
    DELETE_HOST_EVENT,
    DELETE_ADMIN_EVENT,
    HOST_RAISE_HAND,
    HOST_DECLINES,
    HOST_PROPOSES,
    UPDATE_EVENT_ERROR,
    GET_EVENTS_OFFERED_TO_HOST,
    GET_EVENTS_NEAR_ME_TO_HOST,
    GET_EVENT_BY_ID,
    GET_DISCOVERABLE_EVENTS,
    GET_THIS_ARTIST_BOOKING_EVENTS,
    GET_THIS_ARTIST_EVENTS,
    GET_ALL_EVENTS,
    ARTIST_VIEWED_HOST_OFFER,
    ARTIST_DECLINED_HOST_OFFER,
    ARTIST_ACCEPTED_HOST_OFFER,
    EVENTS_ERROR,
    AUTH_ERROR,
    CANCEL_EVENT,
    UPDATE_EVENT_DATE,
    VERIFY_EVENT_ATTENDEE,
} from './types';

import { alertErrorDispatch } from './app';

// Confirmed host updates specific offer fields on an existing event.
// Does NOT dispatch into the event store -- the caller is responsible for
// refreshing via getEventByID after this resolves to avoid clobbering
// fully-populated fields (artist, confirmedHost, etc.) with the sparse
// PUT response.
export const updateHostOfferFields =
    (eventId, offerFields) => async (dispatch) => {
        try {
            const config = {
                headers: { 'Content-Type': 'application/json' },
            };
            const response = await axios.put(
                `/api/events/hostOfferFields/${eventId}`,
                offerFields,
                config
            );
        } catch (err) {
            console.log('updateHostOfferFields error:', err);
            dispatch({
                type: UPDATE_EVENT_ERROR,
                payload: {
                    msg: err.response?.statusText,
                    status: err.response?.status,
                },
            });
            dispatch(alertErrorDispatch(err));
        }
    };

//Create a host event by bookingWhen and bookingWhere
export const editHostEvent = (formData, history) => async (dispatch) => {
    try {
        //console.log('hostRaiseHand formData', formData);
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        const res = await axios.post('/api/events/hostEvent', formData, config);
        // console.log('editHostEvent res.data', res.data);
        dispatch({
            type: EDIT_HOST_EVENT,
            payload: res.data,
        });
        // dispatch(
        //     setAlert(
        //         'Your offer to host the show on ' +
        //             new Date(formData.bookingWhen).toLocaleDateString(
        //                 undefined,
        //                 {
        //                     weekday: 'long',
        //                     year: 'numeric',
        //                     month: 'long',
        //                     day: 'numeric',
        //                 }
        //             ) +
        //             ' was submitted.',
        //         'success'
        //     )
        // ); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
    } catch (err) {
        console.log('error: ' + err);
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: UPDATE_EVENT_ERROR,
            payload: {
                msg: err.response.statusText,
                status: err.response.status,
            },
        });
        dispatch(alertErrorDispatch(err));
        // dispatch(setAlert('Update Error: ' + err, 'danger')); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
    }
};

//Delete an admin event by id
export const deleteAdminEvent = (eventData) => async (dispatch) => {
    //console.log('deleteAdminEvent eventData: ', eventData);
    try {
        const res = await axios.delete(
            `/api/events/adminEvent/${eventData._id}`,
            {
                data: {
                    bookingWhen: eventData.bookingWhen,
                    createdBy: eventData.createdBy,
                    status: eventData.status,
                    createdAt: eventData.createdAt,
                },
            }
        );
        dispatch({
            type: DELETE_ADMIN_EVENT,
            payload: res.data,
        });
    } catch (err) {
        console.log('error: ' + err);
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: UPDATE_EVENT_ERROR,
            payload: {
                msg: err.response.statusText,
                status: err.response.status,
            },
        });
        dispatch(alertErrorDispatch(err));
        // dispatch(setAlert('Update Error: ' + err, 'danger')); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
    }
};

//Delete a host event by id
export const deleteHostEvent = (id) => async (dispatch) => {
    try {
        const res = await axios.delete(`/api/events/hostEvent/${id}`);
        dispatch({
            type: DELETE_HOST_EVENT,
            payload: res.data,
        });
    } catch (err) {
        console.log('error: ' + err);
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: UPDATE_EVENT_ERROR,
            payload: {
                msg: err.response.statusText,
                status: err.response.status,
            },
        });
        dispatch(alertErrorDispatch(err));
        // dispatch(setAlert('Update Error: ' + err, 'danger')); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
    }
};

//Cancel an event by id
export const cancelEvent = (formData, history) => async (dispatch) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        const res = await axios.post(
            `/api/events/cancelEvent/${formData._id}`,
            formData,
            config
        );
        dispatch({
            type: CANCEL_EVENT,
            payload: {
                _id: res.data,
                canceledReason: formData.canceledReason,
                canceledBy: formData.canceledBy,
                canceledDate: new Date().toISOString(),
            },
        });
        const formattedEventDate = formData.bookingWhen
            ? new Date(formData.bookingWhen).toLocaleDateString(undefined, {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  timeZone: 'UTC', //fixes timezone issues where users see the date a day off sometimes
              })
            : null;
        dispatch(
            setAlert(
                formattedEventDate
                    ? `That event on ${formattedEventDate} is canceled.`
                    : 'That event has been canceled.',
                'success'
            )
        );
        console.log(res.data);
    } catch (err) {
        console.log('error: ', err);
        if (err.response && err.response.data) {
            const error = err.response.data;
            console.log('ERROR: ', error);
            if (error) {
                dispatch(setAlert(error, 'danger'));
            }
        }
        // dispatch({
        //     type: UPDATE_EVENT_ERROR,
        //     payload: {
        //         msg: err.response.statusText,
        //         status: err.response.status,
        //     },
        // });
        // dispatch(setAlert('Update Error: ' + err, 'danger')); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
    }
};

// Update an event's date (bookingWhen) for HOST confirmed events
export const updateEventDate =
    (eventId, nextDateIso, options = {}) =>
    async (dispatch) => {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            const res = await axios.post(
                `/api/events/updateDate/${eventId}`,
                { bookingWhen: nextDateIso, ...options },
                config
            );
            dispatch({ type: UPDATE_EVENT_DATE, payload: res.data });
            // Optionally notify success
            // dispatch(setAlert('Date updated.', 'success'));
        } catch (err) {
            const message = err?.response?.data || 'Unable to update date';
            dispatch({
                type: UPDATE_EVENT_ERROR,
                payload: {
                    msg: err?.response?.statusText || message,
                    status: err?.response?.status,
                },
            });
            dispatch(setAlert(String(message), 'danger'));
            dispatch(alertErrorDispatch(err));
        }
    };

//Create an artist event by bookingWhen and bookingWhere
export const editArtistEvent = (formData, history) => async (dispatch) => {
    try {
        //console.log('hostRaiseHand formData', formData);
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        const res = await axios.post(
            '/api/events/artistEvent',
            formData,
            config
        );
        // console.log('editArtistEvent res.data', res.data);
        dispatch({
            type: EDIT_ARTIST_EVENT,
            payload: res.data,
        });
        // dispatch(
        //     setAlert(
        //         'Your offer to host the show on ' +
        //             new Date(formData.bookingWhen).toLocaleDateString(
        //                 undefined,
        //                 {
        //                     weekday: 'long',
        //                     year: 'numeric',
        //                     month: 'long',
        //                     day: 'numeric',
        //                 }
        //             ) +
        //             ' was submitted.',
        //         'success'
        //     )
        // ); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
    } catch (err) {
        console.log('error: ' + err);
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: UPDATE_EVENT_ERROR,
            payload: {
                msg: err.response.statusText,
                status: err.response.status,
            },
        });
        dispatch(alertErrorDispatch(err));
        // dispatch(setAlert('Update Error: ' + err, 'danger')); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
    }
};

//Delete an artist event by id
export const deleteArtistEvent = (id) => async (dispatch) => {
    //console.log('deleteArtistEvent id', id);
    try {
        const res = await axios.delete(`/api/events/artistEvent/${id}`);
        //console.log('hostRaiseHand res.data', res.data);
        dispatch({
            type: DELETE_ARTIST_EVENT,
            payload: res.data,
        });
    } catch (err) {
        console.log('error: ' + err);
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: UPDATE_EVENT_ERROR,
            payload: {
                msg: err.response.statusText,
                status: err.response.status,
            },
        });
        dispatch(alertErrorDispatch(err));
        // dispatch(setAlert('Update Error: ' + err, 'danger')); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
    }
};

// Get the events that I've offered to host
export const getMyEventsOfferedToHost = () => async (dispatch) => {
    try {
        const res = await axios.get(`/api/events/myEventsOfferedToHost`);
        //console.log('res', res);

        dispatch({
            type: GET_EVENTS_OFFERED_TO_HOST,
            payload: res.data,
        });
    } catch (err) {
        //dispatch({ type: CLEAR_ARTIST });
        dispatch({
            type: EVENTS_ERROR,
            payload: {
                msg: err.response.statusText,
                status: err.response.status,
            },
        });
    }
};

// Get the events that I've offered to host
export const getEventByID = (eventID, token) => async (dispatch) => {
    try {
        const res = await axios.get(
            `/api/events/event/${eventID}${token ? `?token=${encodeURIComponent(token)}` : ''}`
        );

        dispatch({
            type: GET_EVENT_BY_ID,
            payload: res.data,
        });
        // Visiting an invite-only event with a token can persist it onto the attendee profile.
        // Refresh attendee state so the dashboard reflects that write without a full reload.
        if (token) {
            try {
                await dispatch(getCurrentAttendee());
            } catch (_) {}
        }
    } catch (err) {
        //dispatch({ type: CLEAR_ARTIST });
        const data = err?.response?.data;
        const code = data?.code;
        try {
            if (token && code === 'TOKEN_EXPIRED') {
                console.warn(
                    `[getEventByID] invite token in URL is EXPIRED for event ${eventID}` +
                        (data?.expiredAt ? ` (expired ${data.expiredAt})` : '')
                );
            } else if (token && code === 'TOKEN_INVALID') {
                console.warn(
                    `[getEventByID] invite token in URL is INVALID (no matching invite) for event ${eventID}`
                );
            } else if (token) {
                console.warn(
                    `[getEventByID] invite token in URL was not accepted for event ${eventID}`,
                    { code, status: err?.response?.status }
                );
            }
        } catch (_) {}
        dispatch({
            type: EVENTS_ERROR,
            payload: {
                msg: err?.response?.statusText,
                status: err?.response?.status,
                code,
                expiredAt: data?.expiredAt,
            },
        });
    }
};

// Get event by ID for current user (includes isAttending)
export const getEventByIDMe = (eventID) => async (dispatch) => {
    try {
        const res = await axios.get(`/api/events/event/${eventID}/me`);
        dispatch({ type: GET_EVENT_BY_ID, payload: res.data });
    } catch (err) {
        dispatch({
            type: EVENTS_ERROR,
            payload: {
                msg: err?.response?.statusText,
                status: err?.response?.status,
            },
        });
    }
};

// RSVP to an event
export const rsvpToEvent =
    (eventID, counts = {}, token) =>
    async (dispatch) => {
        try {
            const tokenQS = token ? `?token=${encodeURIComponent(token)}` : '';
            await axios.post(`/api/events/${eventID}/rsvp${tokenQS}`, counts);
            try {
                await dispatch(getCurrentAttendee());
            } catch (_) {}
            // Refresh full event if allowed (PUBLIC or token-authorized)
            try {
                const eventRes = await axios.get(
                    `/api/events/event/${eventID}${tokenQS}`
                );
                dispatch({ type: GET_EVENT_BY_ID, payload: eventRes.data });
            } catch (_) {}
            // Refresh with attendance flag for current user
            try {
                const meRes = await axios.get(
                    `/api/events/event/${eventID}/me`
                );
                dispatch({ type: GET_EVENT_BY_ID, payload: meRes.data });
            } catch (_) {}
            dispatch(setAlert('You’re on the list. See you there!', 'success'));
        } catch (err) {
            const explicitMessage =
                err?.response?.data?.message ||
                (typeof err?.response?.data === 'string'
                    ? err.response.data
                    : null);
            dispatch({
                type: EVENTS_ERROR,
                payload: {
                    msg:
                        err?.response?.statusText ||
                        explicitMessage ||
                        'Unable to RSVP',
                    status: err?.response?.status,
                },
            });
            if (explicitMessage) {
                dispatch(setAlert(explicitMessage, 'danger'));
            } else {
                dispatch(
                    setAlert(
                        'We couldn’t save your seat just yet. Please try again in a moment.',
                        'danger'
                    )
                );
                dispatch(alertErrorDispatch(err));
            }
        }
    };

// Cancel RSVP
export const cancelRsvp = (eventID, token) => async (dispatch) => {
    try {
        await axios.delete(`/api/events/${eventID}/rsvp`);
        try {
            await dispatch(getCurrentAttendee());
        } catch (_) {}
        const tokenQS = token ? `?token=${encodeURIComponent(token)}` : '';
        // Refresh event if allowed (PUBLIC or token-authorized)
        try {
            const eventRes = await axios.get(
                `/api/events/event/${eventID}${tokenQS}`
            );
            dispatch({ type: GET_EVENT_BY_ID, payload: eventRes.data });
        } catch (_) {}
        // Refresh with attendance flag for current user
        try {
            const meRes = await axios.get(`/api/events/event/${eventID}/me`);
            dispatch({ type: GET_EVENT_BY_ID, payload: meRes.data });
        } catch (_) {}
        dispatch(setAlert('Your RSVP was canceled.', 'success'));
    } catch (err) {
        dispatch({
            type: EVENTS_ERROR,
            payload: {
                msg: err?.response?.statusText || 'Unable to cancel RSVP',
                status: err?.response?.status,
            },
        });
        dispatch(alertErrorDispatch(err));
    }
};

// Set attendance visibility (PUBLIC | PRIVATE | VERIFIED | NONE) for an event (HOST only)
export const setAttendanceVisibility =
    (eventID, visibility) => async (dispatch) => {
        try {
            const res = await axios.post(
                `/api/events/${eventID}/attendance-visibility`,
                { visibility }
            );
            dispatch({ type: GET_EVENT_BY_ID, payload: res.data });
        } catch (err) {
            dispatch({
                type: EVENTS_ERROR,
                payload: {
                    msg:
                        err?.response?.statusText ||
                        'Unable to update visibility',
                    status: err?.response?.status,
                },
            });
            dispatch(alertErrorDispatch(err));
        }
    };

// Hide/show tour vibe or alcohol on the attendee event page (confirmed HOST only)
// field: 'tourVibe' | 'alcohol'
export const setEventDetailVisibility =
    (eventID, field, hidden) => async (dispatch) => {
        try {
            const res = await axios.post(
                `/api/events/${eventID}/detail-visibility`,
                { field, hidden }
            );
            dispatch({ type: GET_EVENT_BY_ID, payload: res.data });
        } catch (err) {
            dispatch({
                type: EVENTS_ERROR,
                payload: {
                    msg:
                        err?.response?.statusText ||
                        'Unable to update detail visibility',
                    status: err?.response?.status,
                },
            });
            dispatch(alertErrorDispatch(err));
        }
    };

// Set the opening acts for an event (the event's artist or the confirmed host)
export const setEventOpeners = (eventID, eventOpeners) => async (dispatch) => {
    try {
        const res = await axios.post(`/api/events/${eventID}/event-openers`, {
            eventOpeners,
        });
        dispatch({ type: GET_EVENT_BY_ID, payload: res.data });
    } catch (err) {
        dispatch({
            type: EVENTS_ERROR,
            payload: {
                msg:
                    err?.response?.statusText ||
                    'Unable to update the opening acts',
                status: err?.response?.status,
            },
        });
        dispatch(alertErrorDispatch(err));
    }
};

// Get the events that are near me to host
export const getEventsNearMeToHost = () => async (dispatch) => {
    try {
        const res = await axios.get(`/api/events/nearMeToHost`);
        // console.log('getEventsNearMeToHost() res', res);
        dispatch({
            type: GET_EVENTS_NEAR_ME_TO_HOST,
            payload: res.data,
        });
    } catch (err) {
        //dispatch({ type: CLEAR_ARTIST });
        dispatch({
            type: EVENTS_ERROR,
            payload: {
                msg: err.response.statusText,
                status: err.response.status,
            },
        });
    }
};
// Get the events that this artist is trying to book
export const getArtistBookingEvents = (artistSlug) => async (dispatch) => {
    try {
        const res = await axios.get(
            `/api/events/getArtistBooking/${artistSlug}`
        );
        dispatch({
            type: GET_THIS_ARTIST_BOOKING_EVENTS,
            payload: res.data,
        });
    } catch (err) {
        //dispatch({ type: CLEAR_ARTIST });
        dispatch({
            type: EVENTS_ERROR,
            payload: {
                msg: err.response.statusText,
                status: err.response.status,
            },
        });
    }
};
//Get current user's artist's events where the hostsOfferingToBook has at least one index
export const getMyArtistEventsOffers = () => async (dispatch) => {
    try {
        const res = await axios.get(`/api/events/myArtistEvents/`);
        dispatch({
            type: GET_THIS_ARTIST_EVENTS,
            payload: res.data,
        });
    } catch (err) {
        //dispatch({ type: CLEAR_ARTIST });
        dispatch({
            type: EVENTS_ERROR,
            payload: {
                msg: err.response.statusText,
                status: err.response.status,
            },
        });
    }
};

//Get different artist's events where the hostsOfferingToBook has at least one index
export const getDiffArtistEventsOffers = (artistEmail) => async (dispatch) => {
    try {
        // console.log('getDiffArtistEventsOffers() artistEmail', artistEmail);
        const res = await axios.get(
            `/api/events/diffArtistEvents?artistEmail=${artistEmail}`
        );
        dispatch({
            type: GET_THIS_ARTIST_EVENTS,
            payload: res.data,
        });
        console.log('getDiffArtistEventsOffers() res.data', res.data);
    } catch (err) {
        //dispatch({ type: CLEAR_ARTIST });
        dispatch({
            type: EVENTS_ERROR,
            payload: {
                msg: err.response.statusText,
                status: err.response.status,
            },
        });
    }
};

// Offer to host a show
export const hostRaiseHand =
    (formData, history) => async (dispatch, getState) => {
        try {
            //console.log('hostRaiseHand formData', formData);
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            const res = await axios.post(
                '/api/events/hostRaiseHand',
                formData,
                config
            );
            //console.log('hostRaiseHand res.data', res.data);
            // The server response excludes `offersFromHosts` (for response size
            // and privacy). Inject a synthetic entry for the current host so
            // client-side selectors like `hasHostOffered` / `shouldShowHostEvent`
            // recognize this event in `myHostEvents` without needing a refresh.
            const state = getState ? getState() : null;
            const hostId =
                state && state.host && state.host.me && state.host.me._id;
            const payloadWithOffer =
                hostId && formData && formData.theOffer
                    ? {
                          ...res.data,
                          offersFromHosts: [
                              {
                                  ...formData.theOffer,
                                  host: hostId,
                              },
                          ],
                      }
                    : res.data;
            dispatch({
                type: HOST_RAISE_HAND,
                payload: payloadWithOffer,
            });
            dispatch(
                setAlert(
                    'Your offer to host the show on ' +
                        new Date(formData.bookingWhen).toLocaleDateString(
                            undefined,
                            {
                                weekday: 'long',
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric',
                                timeZone: 'UTC', //fixes timezone issues where users see the date a day off sometimes
                            }
                        ) +
                        ' was submitted.',
                    'success'
                )
            ); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
        } catch (err) {
            console.log('error: ' + err);
            const errors = err.response.data.errors;
            if (errors) {
                errors.forEach((error) =>
                    dispatch(setAlert(error.msg, 'danger'))
                );
            }
            dispatch({
                type: UPDATE_EVENT_ERROR,
                payload: {
                    msg: err.response.statusText,
                    status: err.response.status,
                },
            });
            dispatch(alertErrorDispatch(err));
            // dispatch(setAlert('Update Error: ' + err, 'danger')); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
        }
    };
// Decline to host a show
export const hostDeclines = (hostMeID, theEvent) => async (dispatch) => {
    try {
        const formData = { hostMeID, theEvent };
        // console.log('hostDeclines formData', formData);
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        const res = await axios.post(
            `/api/events/hostDeclines/${theEvent._id}`,
            formData,
            config
        );
        const declinedEvent = res.data;

        if (!declinedEvent?._id || !declinedEvent?.artist) {
            throw new Error('The event could not be found.');
        }

        // console.log('hostDeclines res.data', declinedEvent);
        dispatch({
            type: HOST_DECLINES,
            payload: declinedEvent,
        });
        dispatch(
            setAlert(
                'You declined to host the ' +
                    declinedEvent.artist.stageName +
                    ' show on ' +
                    new Date(declinedEvent.bookingWhen).toLocaleDateString(
                        undefined,
                        {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            timeZone: 'UTC', //fixes timezone issues where users see the date a day off sometimes
                        }
                    ) +
                    '.',
                'success'
            )
        ); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
        return declinedEvent;
    } catch (err) {
        console.log('error: ' + err);
        if (err) {
            dispatch({
                type: UPDATE_EVENT_ERROR,
                payload: {
                    msg: err,
                },
            });
            // dispatch(setAlert('Update Error: ' + err, 'danger')); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
        }
        return null;
    }
};

// Host submits proposal — update the status of the event in the database to PENDING, no longer DRAFT
export const hostProposes = (formData, history) => async (dispatch) => {
    try {
        //console.log('hostRaiseHand formData', formData);
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        const res = await axios.post(
            '/api/events/hostProposes',
            formData,
            config
        );
        // console.log('hostProposes res.data', res.data);
        dispatch({
            type: HOST_PROPOSES,
            payload: res.data,
        });
        dispatch(
            setAlert(
                'Your proposal to host the concert on ' +
                    new Date(formData.bookingWhen).toLocaleDateString(
                        undefined,
                        {
                            weekday: 'long',
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            timeZone: 'UTC', //fixes timezone issues where users see the date a day off sometimes
                        }
                    ) +
                    ' was sent.',
                'success'
            )
        ); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
    } catch (err) {
        console.log('error: ' + err);
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: UPDATE_EVENT_ERROR,
            payload: {
                msg: err.response.statusText,
                status: err.response.status,
            },
        });
        dispatch(alertErrorDispatch(err));
        // dispatch(setAlert('Update Error: ' + err, 'danger')); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
    }
};

// Artist viewed Host's offer to book
export const artistViewedHostOffer =
    (theHost, theEvent, history) => async (dispatch) => {
        let formData = {
            bookingWhen: theEvent,
            offeringHost: { _id: theHost },
        };
        //console.log('artistViewedHostOffer formData', formData);
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            //let formData = { ...theEvent, offeringHost: theHost };
            const res = await axios.post(
                '/api/events/artistViewedHostOffer',
                formData,
                config
            );
            //console.log('artistViewedHostOffer res.data:', res.data);
            dispatch({
                type: ARTIST_VIEWED_HOST_OFFER,
                payload: res.data,
            });
        } catch (err) {
            console.log('error: ' + err);
            const errors = err.response.data.errors;

            if (errors) {
                errors.forEach((error) =>
                    dispatch(setAlert(error.msg, 'danger'))
                );
            }
            dispatch({
                type: UPDATE_EVENT_ERROR,
                payload: {
                    msg: err.response.statusText,
                    status: err.response.status,
                },
            });
            //dispatch(setAlert('Update Error: ' + err, 'danger')); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
        }
    };

// Artist declined Host's offer to book
export const artistDeclinedHostOffer =
    (theHost, theEvent, history) => async (dispatch) => {
        let formData = {
            bookingWhen: theEvent,
            offeringHost: { _id: theHost },
        };
        //console.log('artistViewedHostOffer formData', formData);
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            //let formData = { ...theEvent, offeringHost: theHost };
            const res = await axios.post(
                '/api/events/artistDeclineOffer',
                formData,
                config
            );
            //console.log('artistViewedHostOffer res.data:', res.data);
            dispatch({
                type: ARTIST_DECLINED_HOST_OFFER,
                payload: res.data,
            });
        } catch (err) {
            console.log('error: ' + err);
            const errors = err.response.data.errors;

            if (errors) {
                errors.forEach((error) =>
                    dispatch(setAlert(error.msg, 'danger'))
                );
            }
            dispatch({
                type: UPDATE_EVENT_ERROR,
                payload: {
                    msg: err.response.statusText,
                    status: err.response.status,
                },
            });
            //dispatch(setAlert('Update Error: ' + err, 'danger')); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
        }
    };

// Artist accepted Host's offer to book
export const artistAcceptOffer =
    (bookingWhen, theOffer, stageName, history) => async (dispatch) => {
        let formData = {
            bookingWhen: bookingWhen,
            offeringHost: { _id: theOffer.host._id },
            theOffer: theOffer,
            stageName: stageName,
        };
        // console.log('artistAcceptOffer theOffer', theOffer);
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            //let formData = { ...theEvent, offeringHost: theHost };
            const res = await axios.post(
                '/api/events/artistAcceptOffer',
                formData,
                config
            );
            //console.log('artistAcceptOffer res.data:', res.data);
            dispatch({
                type: ARTIST_ACCEPTED_HOST_OFFER,
                payload: res.data,
            });
            dispatch(
                setAlert(
                    'You accepted ' +
                        theOffer.host.firstName +
                        ' ' +
                        theOffer.host.lastName +
                        '’s offer to host your concert on ' +
                        new Date(formData.bookingWhen).toLocaleDateString(
                            undefined,
                            {
                                weekday: 'long',
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric',
                                timeZone: 'UTC', //fixes timezone issues where users see the date a day off sometimes
                            }
                        ) +
                        '. Someone will be in touch soon!',
                    'success'
                )
            ); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
        } catch (err) {
            //console.log('error: ' + err);
            const errors = err.response.data.errors;

            if (errors) {
                errors.forEach((error) =>
                    dispatch(setAlert(error.msg, 'danger'))
                );
            }
            dispatch({
                type: UPDATE_EVENT_ERROR,
                payload: {
                    msg: err.response.statusText,
                    status: err.response.status,
                },
            });
            dispatch(alertErrorDispatch(err));
            //dispatch(setAlert('Update Error: ' + err, 'danger')); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
        }
    };

export const verifyEventAttendee =
    (eventId, userId, verified) => async (dispatch) => {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            const res = await axios.patch(
                `/api/events/${eventId}/attendees/${userId}/verification`,
                { verified },
                config
            );
            dispatch({
                type: VERIFY_EVENT_ATTENDEE,
                payload: res.data,
            });
            return res.data;
        } catch (err) {
            dispatch({
                type: UPDATE_EVENT_ERROR,
                payload: {
                    msg: err.response?.statusText,
                    status: err.response?.status,
                },
            });
            dispatch(alertErrorDispatch(err));
            throw err;
        }
    };

//Get all events for [ADMIN, BOOKING]
export const getAllEvents = () => async (dispatch) => {
    try {
        const res = await axios.get('/api/events/edit');
        //res.data.avatar = await axios.get('/api/artists/my-avatar');
        dispatch({
            type: GET_ALL_EVENTS,
            payload: res.data,
        });
    } catch (err) {
        dispatch({
            type: AUTH_ERROR,
        });
    }
};

export const getDiscoverableEvents = () => async (dispatch) => {
    try {
        const res = await axios.get('/api/events/discover');
        dispatch({
            type: GET_DISCOVERABLE_EVENTS,
            payload: Array.isArray(res.data) ? res.data : [],
        });
        return res.data;
    } catch (err) {
        dispatch({
            type: EVENTS_ERROR,
            payload: {
                msg: err?.response?.statusText || 'Unable to load concerts',
                status: err?.response?.status,
            },
        });
        dispatch(alertErrorDispatch(err));
        return [];
    }
};
